type Sizes = 'sm' | 'lg'

export function getImageUrl(
	size: Sizes,
	url?: string,
	category = 'default'
): string {
	return url || `/assets/article/placeholder/${category}_${size}.jpg`
}
